import React, { useState } from 'react';
import gqlService from '@core_modules/checkout/services/graphql';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectCheckoutState, setCheckoutData,
} from '@core_modules/checkout/redux/checkoutSlice';

const Email = (props) => {
    const {
        EmailView,
        formik,
        handleOpenMessage,
        t,
        cartId,
    } = props;

    const dispatch = useDispatch();
    const checkout = useSelector(selectCheckoutState);

    const [anchorEl, setAnchorEl] = useState(null);
    const [setGuestEmailAddressOnCart] = gqlService.setGuestEmailAddressOnCart(({ onError: () => {} }));
    const [checkExistingEmail] = gqlService.checkingCustomer(({ onError: () => {} }));
    const [load, setLoad] = useState(false);
    const open = Boolean(anchorEl);
    const id = open ? 'email-helper' : undefined;
    const [showLoginForm, setShowLoginForm] = React.useState(false);
    const [email, setEmail] = React.useState('');

    const handleBlur = async () => {
        formik.setFieldTouched('email', true);
        setShowLoginForm(false);
        if (formik.values.email !== formik.values.oldEmail && !formik.errors.email) {
            const idCart = checkout && checkout.data && checkout.data.cart && checkout.data.cart.id;
            setLoad(true);
            const emailResult = await checkExistingEmail({
                variables: {
                    email: formik.values.email,
                },
            });

            if (!emailResult || emailResult.errors) {
                handleOpenMessage({
                    variant: 'error',
                    text: t('checkout:message:problemConnection'),
                });
                setLoad(false);
            } else if (emailResult?.data?.checkingCustomer[0]?.is_exist && !emailResult?.errors) {
                // handleOpenMessage({
                //     variant: 'error',
                //     text: emailResult?.data?.checkingCustomer[0]?.message || 'Email already exist',
                // });
                setLoad(false);
                setShowLoginForm(true);
                setEmail(formik.values.email);
            } else {
                const result = await setGuestEmailAddressOnCart({
                    variables: {
                        cartId: idCart ? checkout.data.cart.id : cartId,
                        email: formik.values.email,
                    },
                });
                if (!result || result.errors) {
                    handleOpenMessage({
                        variant: 'error',
                        text: t('checkout:message:problemConnection'),
                    });
                    setLoad(false);
                } else {
                    await formik.setFieldValue('oldEmail', formik.values.email);
                    if (result?.data?.setGuestEmailOnCart?.cart) {
                        dispatch(setCheckoutData({
                            cart: {
                                ...checkout.data.cart,
                                ...result.data.setGuestEmailOnCart.cart,
                            },
                        }));
                    }
                    setLoad(false);
                }
                setShowLoginForm(false);
            }
        }
    };

    const content = (
        <EmailView
            {...props}
            idButton={id}
            open={open}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            handleBlur={handleBlur}
            load={load}
            loadingAll={checkout?.loading?.all}
            showLoginForm={showLoginForm}
            emailGuest={email}
        />
    );

    return checkout.data.isGuest ? content : null;
};

export default Email;
